"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTrackRecordProperty = exports.trackRecordPropertyDefinition = void 0;
exports.trackRecordPropertyDefinition = {
    view: { label: 'Track record' },
    constraints: [
        {
            name: 'orderedProperties',
            argument: [
                'year',
                'record',
                'location',
                'record-description',
                'record-discipline',
            ],
        },
    ],
    type: 'ordered-container',
    multiple: true,
    name: 'track-record',
};
const isTrackRecordProperty = (prop) => {
    return prop.name === exports.trackRecordPropertyDefinition.name;
};
exports.isTrackRecordProperty = isTrackRecordProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHJhY2stcmVjb3JkLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvdHJhY2stcmVjb3JkLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQU1hLFFBQUEsNkJBQTZCLEdBQUc7SUFDM0MsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLGNBQWMsRUFBRTtJQUMvQixXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxtQkFBbUI7WUFDekIsUUFBUSxFQUFFO2dCQUNSLE1BQU07Z0JBQ04sUUFBUTtnQkFDUixVQUFVO2dCQUNWLG9CQUFvQjtnQkFDcEIsbUJBQW1CO2FBQ3BCO1NBQ0Y7S0FDRjtJQUNELElBQUksRUFBRSxtQkFBbUI7SUFDekIsUUFBUSxFQUFFLElBQUk7SUFDZCxJQUFJLEVBQUUsY0FBYztDQUNXLENBQUE7QUFXMUIsTUFBTSxxQkFBcUIsR0FBRyxDQUFDLElBQWtCLEVBQStCLEVBQUU7SUFDdkYsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLHFDQUE2QixDQUFDLElBQUksQ0FBQTtBQUN6RCxDQUFDLENBQUE7QUFGWSxRQUFBLHFCQUFxQix5QkFFakMifQ==